// this simply returns a unique key to distinguish requests according to filters

const getCacheKey = (packCode: string, startDate: string, endDate: string, season: string, participants: Array<number>): string => {
    return `${packCode} - ${startDate} - ${endDate} - ${season} - ${JSON.stringify(participants)}`
}

export default getCacheKey